import {object, string} from 'yup'

export const danceSchema = object({
    nameHeb: string().required('required'),
    nameEng: string().required('required'),
})
